import { useContext, useEffect } from 'react'

import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { faIdBadge, faUser } from '@fortawesome/pro-solid-svg-icons'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { InstitutionGroupContext } from '../../../Providers/InstitutionGroupProvider'
import Analytics from '../../../utils/analytics'
import IconLabel from '../../../Components/icons/IconLabel'
import InternshipsReporting from './InternshipsReporting'
import { Contexts, InstitutionRoles } from '../../../utils/constants'
import BadgesView from './BadgesView'

const { TabPane } = Tabs

const ReportingPage = () => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const institutionGroupContext = useContext(InstitutionGroupContext)

  useEffect(() => {
    Analytics.pageView('/institution-badge')
  }, [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={<IconLabel icon={faUser} text={t('View students informations')} style={{ marginTop: '3px' }} />}
      >
        <InternshipsReporting institutions={institutionGroupContext?.institutions} />
      </TabPane>
      {user.context === Contexts.INSTITUTION && !user.roles.includes(InstitutionRoles.INSTITUTION_GROUP_ADMIN) && (
        <TabPane
          key='2'
          tab={<IconLabel icon={faIdBadge} text={t('Manage badges assignations')} style={{ marginTop: '3px' }} />}
        >
          <BadgesView />
        </TabPane>
      )}
    </Tabs>
  )
}

export default ReportingPage
